import { useTranslations } from "next-intl";
import {
  getDestinations as getDestinationsData,
  getDestinationsByRegion,
} from "./destinationData";

type RegionKey =
  | "europe"
  | "asia"
  | "northAmerica"
  | "southAmerica"
  | "africa"
  | "oceania"
  | "middleEast";

const countryToRegion: Record<string, RegionKey> = {
  // Europe
  AT: "europe",
  BE: "europe",
  BG: "europe",
  HR: "europe",
  CY: "europe",
  CZ: "europe",
  DK: "europe",
  EE: "europe",
  FI: "europe",
  FR: "europe",
  DE: "europe",
  GR: "europe",
  HU: "europe",
  IS: "europe",
  IE: "europe",
  IT: "europe",
  LV: "europe",
  LT: "europe",
  LU: "europe",
  MT: "europe",
  NL: "europe",
  PL: "europe",
  PT: "europe",
  RO: "europe",
  SK: "europe",
  SI: "europe",
  ES: "europe",
  SE: "europe",
  GB: "europe",
  NO: "europe",
  UA: "europe",
  CH: "europe",

  // Asia
  JP: "asia",
  KR: "asia",
  CN: "asia",
  IN: "asia",
  SG: "asia",
  TH: "asia",
  VN: "asia",
  MY: "asia",
  ID: "asia",
  PH: "asia",
  BD: "asia",
  PK: "asia",
  NP: "asia",
  KH: "asia",

  // Middle East
  AE: "middleEast",
  SA: "middleEast",
  IL: "middleEast",
  QA: "middleEast",
  OM: "middleEast",
  KW: "middleEast",
  TR: "middleEast",
  JO: "middleEast",

  // North America
  US: "northAmerica",
  CA: "northAmerica",
  MX: "northAmerica",
  GT: "northAmerica",
  CR: "northAmerica",
  PA: "northAmerica",

  // South America
  BR: "southAmerica",
  AR: "southAmerica",
  CO: "southAmerica",
  CL: "southAmerica",
  PE: "southAmerica",
  VE: "southAmerica",
  EC: "southAmerica",
  UY: "southAmerica",
  BO: "southAmerica",

  // Africa
  ZA: "africa",
  NG: "africa",
  KE: "africa",
  EG: "africa",
  DZ: "africa",
  MA: "africa",
  TZ: "africa",
  GH: "africa",

  // Oceania
  AU: "oceania",
  NZ: "oceania",
  FJ: "oceania",
  PG: "oceania",
  NC: "oceania",
  PF: "oceania",
};

function getRegionFromCountryCode(countryCode: string): RegionKey | null {
  return countryToRegion[countryCode.toUpperCase()] || null;
}

export const getDestinations = (
  t: ReturnType<typeof useTranslations>,
  userCountryCode: string
) => {
  const regionKey = getRegionFromCountryCode(userCountryCode);
  const destinationsByRegion = getDestinationsByRegion(t);

  if (regionKey && regionKey in destinationsByRegion) {
    const destinations = destinationsByRegion[regionKey];
    return destinations;
  } else {
    return getDestinationsData(t);
  }
};
